import { Box, Typography, styled, useTheme } from "@mui/material";

const ProfileStatue = ({ text, label, condition }) => {
  const theme = useTheme();

  return (
    <BoxProfileStatue
      color={condition ? theme.palette.success.main : theme.palette.error.main}
    >
      <Box display="flex" minWidth="80px" justifyContent="flex-end">
        <Typography
          component="span"
          variant="h6"
          color={condition ? "success.main" : "error.main"}
        >
          {text}
        </Typography>
        <Typography color={condition ? "success.main" : "error.main"} pl={0.5}>
          {condition ? (
            <ion-icon name="checkmark-circle-outline" />
          ) : (
            <ion-icon name="close-circle-outline" />
          )}
        </Typography>
      </Box>

      <Typography dir="rtl" variant="h6" component="span">
        {label}
      </Typography>
    </BoxProfileStatue>
  );
};

const BoxProfileStatue = styled(({ color, ...props }) => <Box {...props} />)(
  ({ color, theme }) => ({
    display: "flex",
    maxWidth: "100%",
    textAlign: "right",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.modules.border}`,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(1),

    "&:last-child": {
      borderBottom: "none",
      paddingBottom: 0,
      marginBottom: 0,
    },

    h6: {
      display: "flex",
      alignItems: "center",
      flex: "0 0 60px",
      justifyContent: "space-between",

      "ion-icon": {
        padding: theme.spacing(1),
        color: color,
      },
    },
  })
);
export default ProfileStatue;
